var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgFruitV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E5C8F4",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 23.4995C14.3763 23.4995 12.9978 22.9336 11.8659 21.8016C10.7339 20.6697 10.168 19.2912 10.168 17.6662C10.168 16.3607 10.5534 15.1905 11.3242 14.1558C12.0951 13.1211 13.1055 12.4232 14.3555 12.062C14.0777 11.9926 13.8069 11.8919 13.543 11.76C13.2791 11.628 13.043 11.4579 12.8346 11.2495C12.3763 10.7912 12.0812 10.2461 11.9492 9.61413C11.8173 8.98218 11.786 8.33982 11.8555 7.68704C12.5082 7.6176 13.1506 7.64885 13.7826 7.78079C14.4145 7.91274 14.9596 8.20788 15.418 8.66621C15.7374 8.98565 15.9701 9.34676 16.1159 9.74954C16.2617 10.1523 16.3555 10.5759 16.3971 11.0204C16.5777 10.5898 16.7964 10.1836 17.0534 9.80163C17.3103 9.41968 17.5985 9.06899 17.918 8.74954C18.0707 8.59676 18.2652 8.52038 18.5013 8.52038C18.7374 8.52038 18.9319 8.59676 19.0846 8.74954C19.2374 8.90232 19.3138 9.09676 19.3138 9.33288C19.3138 9.56899 19.2374 9.76343 19.0846 9.91621C18.7791 10.2218 18.5082 10.5586 18.2721 10.9266C18.036 11.2947 17.8624 11.687 17.7513 12.1037C18.9735 12.4926 19.9596 13.1975 20.7096 14.2183C21.4596 15.2391 21.8346 16.3884 21.8346 17.6662C21.8346 19.2912 21.2687 20.6697 20.1367 21.8016C19.0048 22.9336 17.6263 23.4995 16.0013 23.4995Z",
    fill: "#A847DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgFruitV2);
export default __webpack_public_path__ + "static/media/wbg-fruit-v2.2c20fe998482fa0c7481dd195eccb407.svg";
export { ForwardRef as ReactComponent };